import "./invescoGuideAnimation.css";

/**
 * Inline animated SVG that simulates the Invesco portal section the
 * admin needs to interact with. The animation runs in a 6-second loop:
 *   0–2s   highlight the "Partecipazioni" tab + cursor click
 *   2–4s   the table appears, cursor moves to "Visualizza tutto"
 *   4–6s   button click + ghost rows expand (table grows)
 *
 * Pure CSS keyframes, no JS, no images, no third-party libs.
 */
export function InvescoGuideAnimation() {
  return (
    <div
      data-testid="invesco-guide-animation"
      className="invesco-guide-anim"
      aria-label="Animazione guida portale Invesco"
    >
      <svg viewBox="0 0 200 220" xmlns="http://www.w3.org/2000/svg" role="img">
        {/* Browser chrome */}
        <rect x="2" y="2" width="196" height="216" rx="4" fill="#0a0a0a" stroke="#3f3f46" strokeWidth="1" />
        <rect x="2" y="2" width="196" height="14" rx="4" fill="#18181b" />
        <circle cx="9"  cy="9" r="2" fill="#52525b" />
        <circle cx="16" cy="9" r="2" fill="#52525b" />
        <circle cx="23" cy="9" r="2" fill="#52525b" />
        <text x="100" y="12" fontSize="6" fill="#71717a" textAnchor="middle">invesco.com</text>

        {/* ETF page header */}
        <rect x="10" y="22" width="120" height="6" rx="1" fill="#52525b" />
        <rect x="10" y="32" width="80"  height="4" rx="1" fill="#3f3f46" />

        {/* Tabs row — "Partecipazioni" is the 3rd, highlighted in step 1 */}
        <g className="igr-step1">
          <rect x="10"  y="44" width="40" height="14" rx="2" fill="#27272a" />
          <text x="30"  y="53" fontSize="6" fill="#a1a1aa" textAnchor="middle">Profilo</text>
          <rect x="54"  y="44" width="40" height="14" rx="2" fill="#27272a" />
          <text x="74"  y="53" fontSize="6" fill="#a1a1aa" textAnchor="middle">Costi</text>
          {/* Partecipazioni — gets the pulse */}
          <rect className="igr-tab-target"
                x="98"  y="44" width="58" height="14" rx="2"
                fill="#1e3a8a" stroke="#3b82f6" strokeWidth="0.5" />
          <text x="127" y="53" fontSize="6" fill="#dbeafe" textAnchor="middle"
                fontWeight="600">Partecipazioni</text>
        </g>

        {/* Mini table that appears in step 2/3 */}
        <g className="igr-step2">
          <rect x="10" y="66" width="180" height="6" fill="#27272a" />
          <text x="14" y="71" fontSize="4" fill="#a1a1aa">NAME</text>
          <text x="80" y="71" fontSize="4" fill="#a1a1aa">CUSIN</text>
          <text x="120" y="71" fontSize="4" fill="#a1a1aa">ISIN</text>
          <text x="170" y="71" fontSize="4" fill="#a1a1aa">PESO</text>
          {/* Always-visible rows (10 max) */}
          <rect x="10" y="74" width="180" height="6" fill="#0f0f10" />
          <rect x="10" y="82" width="180" height="6" fill="#18181b" />
          <rect x="10" y="90" width="180" height="6" fill="#0f0f10" />
          <rect x="10" y="98" width="180" height="6" fill="#18181b" />
          <rect x="10" y="106" width="180" height="6" fill="#0f0f10" />
          {/* Hidden rows expand on step 3 */}
          <g className="igr-extra-rows">
            <rect x="10" y="114" width="180" height="6" fill="#18181b" />
            <rect x="10" y="122" width="180" height="6" fill="#0f0f10" />
            <rect x="10" y="130" width="180" height="6" fill="#18181b" />
          </g>
        </g>

        {/* "Visualizza tutto" button below the table */}
        <g className="igr-step2">
          <rect className="igr-btn-target"
                x="60" y="146" width="80" height="14" rx="3"
                fill="#1e3a8a" stroke="#3b82f6" strokeWidth="0.5" />
          <text x="100" y="155" fontSize="6" fill="#dbeafe" textAnchor="middle"
                fontWeight="600">Visualizza tutto</text>
        </g>

        {/* Cursor that moves from the tab to the button */}
        <g className="igr-cursor">
          <path d="M 0 0 L 0 10 L 3 7 L 5 11 L 7 10 L 4 6 L 8 6 Z"
                fill="#fafafa" stroke="#0a0a0a" strokeWidth="0.5" />
        </g>

        {/* Step labels at the bottom */}
        <g>
          <rect x="10" y="178" width="180" height="32" rx="3"
                fill="#0a0a0a" stroke="#3f3f46" strokeWidth="0.5" />
          <text x="14" y="190" fontSize="6" fill="#a1a1aa" fontWeight="600">
            <tspan className="igr-label-1">1. Partecipazioni</tspan>
          </text>
          <text x="14" y="202" fontSize="6" fill="#a1a1aa" fontWeight="600">
            <tspan className="igr-label-2">2. Visualizza tutto</tspan>
          </text>
        </g>
      </svg>
    </div>
  );
}
